import { __decorate } from "tslib";
import { ArrayDecoder, AutoEncoder, field } from '@simonbackx/simple-encoding';
import { STCredit } from './STCredit.js';
import { STInvoice, STPendingInvoice } from './STInvoice.js';
import { STPackage } from './STPackage.js';
export class STBillingStatus extends AutoEncoder {
}
__decorate([
    field({ decoder: new ArrayDecoder(STInvoice) })
], STBillingStatus.prototype, "invoices", void 0);
__decorate([
    field({ decoder: new ArrayDecoder(STPackage) })
], STBillingStatus.prototype, "packages", void 0);
__decorate([
    field({ decoder: STPendingInvoice, nullable: true })
], STBillingStatus.prototype, "pendingInvoice", void 0);
__decorate([
    field({ decoder: new ArrayDecoder(STCredit) })
], STBillingStatus.prototype, "credits", void 0);
//# sourceMappingURL=STBillingStatus.js.map